// 配置
export const config = {
  appId: 10007
}
